//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddressInfo from './address-info'
import descStar from '@/assets/jfcj/desc_star.png'
import descBottom from '@/assets/jfcj/bottom_bg.png'
import descNodata from '@/assets/jfcj/shop_default.png'
import { getview } from '@/api/jfhl.js'
import { getUserItem } from '@/api/lottery.js'

export default {
  components: {
    AddressInfo
  },
  data () {
    return {
      desc_star: descStar,
      desc_bottom: descBottom,
      desc_nodata: descNodata,
      partyid: this.$route.params.partyid,
      active: 0,
      lotid: 0,
      awardList: [],
      explist: ''
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  created () {
    this.active = Number(this.$route.params.type)
    this.view()
  },
  methods: {
    view () {
      getview({
        id: this.partyid
      }).then(res => {
        this.lotid = res.obj.lotid
        this.explist = res.obj.explist[0].ATTRCODE
        getUserItem({
          lotid: this.lotid,
          openid: this.accountid
        }).then(res => {
          this.awardList = res.obj.items
        })
      })
    },
    tabChange (item) {
      this.active = item
      this.$router.replace({ name: 'integralDraw7', params: { partyid: this.partyid, type: item } })
    },
    begin () {
      this.$router.push({ name: 'integralDraw8', params: { partyid: this.partyid } })
    },
    address () {
      this.$refs.addressInfo.showDialog()
    }
  }
}
